import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { WarehouseReleaseProductResponse } from './warehouse-release-product.response';

@jsonObject
export class WarehouseReleaseProductCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(WarehouseReleaseProductResponse)
  public readonly good!: WarehouseReleaseProductResponse;
}
